/**
 * Determines the error message to display to the user.
 *
 * @param {string} backendError - The raw error message from the backend.
 * @param {string} [fallbackMessage="Oops! Something went wrong. Please try again."] - The generic message to show if errors are masked.
 * @returns {string} The message to display.
 */
export const isProdEnv = process.env.REACT_APP_PROD_ENV === 'true' || process.env.PROD_ENV === 'true';

/**
 * Determines the error message to display to the user.
 *
 * @param {string} backendError - The raw error message from the backend.
 * @param {string} [fallbackMessage="Oops! Something went wrong. Please try again."] - The generic message to show if errors are masked.
 * @returns {string} The message to display.
 */
export const getPublicErrorMessage = (
  backendError,
  fallbackMessage = 'Oops! Something went wrong. Please try again or contact support.',
) => {
  // If we are NOT in prod, we want to see the errors (log them/show them)
  if (!isProdEnv) {
    return backendError;
  }

  return fallbackMessage;
};
